// useAnalyticsPageView.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { analytics } from '../../firebase';
import { logEvent } from "firebase/analytics";

export function useAnalyticsPageView() {
    const location = useLocation();

    useEffect(() => {
        // Registrar evento de visualização de página
        logEvent(analytics, "page_view", {
            page_path: location.pathname,
            page_location: window.location.href,
            page_title: document.title,
        });
    }, [location]);
}
